
















































































































































import Vue from 'vue';
import { mapGetters } from 'vuex';

import { iconsMixin } from '@/mixins/icons';
import { breakpointsMixin } from '@/mixins/breakpoints';
import { authMixin } from '@/mixins/auth';
import { formatMixin } from '@/mixins/format';

import { UserLookup } from '@/models/admin/UserLookup';

import accountsService from '@/services/AccountsService';
import exportService from '@/services/ExportService';
import localStorageService from '@/services/LocalStorageService';
import sessionStorageService from '@/services/SessionStorageService';
import miscService from '@/services/MiscService';

export default Vue.extend<any, any, any, any>({
  mixins: [iconsMixin, breakpointsMixin, authMixin, formatMixin],
  data() {
    return {
      currentPage: 1,
      pageSize: 10,
      loading: false,
      editing: false,
      displayEditUserPopup: false,
      displayAddUserPopup: false,
      snackbar: false,
      snackbarText: '',
      term: '',
      showFilters: false,
      // access control
      showAccessControl: false,
      allUsers: null,
      accessControl: null,
      currentUser: null,
    };
  },
  created() {
    this.fetch();
  },
  methods: {
    backToPrevPage() {
      history.back();
    },
    onClear() {
      this.term = '';
      this.applyFilters();
    },
    closeFilters() {
      this.showFilters = false;
    },
    fetch() {
      this.loading = true;
      const client = localStorageService.get('selected-afs-client');
      accountsService
        .getLookupAccountUsers(client.id)
        .then((x: UserLookup[]) => {
          this.$store.commit('users/setUsers', x);

          this.applyFilters(true);
          this.loading = false;
        });
    },
    accessSaved(data) {
      console.log('Access saved', data);
    },
    applyFilters(initialSearch) {
      let items = this.all;

      if (this.term) {
        const q = this.term.toLowerCase();
        items = items.filter(
          (x) =>
            x.firstName?.toLowerCase().includes(q) ||
            x.lastName?.toLowerCase().includes(q) ||
            x.email?.toLowerCase().includes(q) ||
            x.phone?.toLowerCase().includes(q) ||
            x.address1?.toLowerCase().includes(q) ||
            x.city?.toLowerCase().includes(q)
        );
      }

      if (initialSearch) {
        items = items.filter((x) => x.active);
      }

      if (!this.searchFilter.active || !this.searchFilter.inactive) {
        items = items.filter(
          (x) =>
            (this.searchFilter.active && x.active) ||
            (this.searchFilter.inactive && !x.active)
        );
      }

      this.$store.commit('users/setFilteredUsers', items);
      this.$store.commit('users/setPage', items.slice(0, this.pageSize));
      this.currentPage = 1;
    },
    onAddUserPopupClose() {
      this.$store.commit('users/setUserToEdit');
    },
    clearFilters() {
      this.term = '';
      this.applyFilters();
    },
    userSaved() {
      this.snackbarText = "Success: Client's user saved!";
      this.snackbar = true;

      this.clearFilters();
    },
    statusChanged(item) {
      accountsService
        .userStatusChange(item.accountId, item.id, item.active)
        .then(() => {
          this.snackbarText = "User's status changed.";
          this.snackbar = true;
        });
    },
    resetFilter() {
      this.term = '';
      this.applyFilters();
    },
    csvExport() {
      const client = localStorageService.get('selected-afs-client');

      this.all?.forEach((x) => {
        if (!x.origCompany) x.origCompany = '';
      });

      const columnOrder = [
        'id',
        'accountId',
        'active',
        'firstName',
        'lastName',
        'phone',
        'email',
        'password',
        'origCompany',
        'address1',
        'address2',
        'city',
        'state',
        'postalCode',
        'country',
        'accountBillAddress1',
        'accountBillAddress2',
        'accountBillCity',
        'accountBillState',
        'accountBillPostalCode',
        'accountBillCountry',
        'billContactName',
        'billEmail',
        'billPhone',
        'billAddress1',
        'billAddress2',
        'billCity',
        'billState',
        'billPostalCode',
        'billCountry',
        'allowQuote',
        'allowBook',
        'allowTrack',
        'productListManagement',
        'visibilityPortal',
        'showTrueCost',
        'viewOthersShipQuotes',
        'defaultOrigin',
        'smarttmsEnabled',
      ];

      exportService.csvDownload(
        this.all,
        `${client?.company}’s Employees`,
        columnOrder
      );
    },
    pageChange(newPage) {
      let page = this.filteredUsers.slice(
        (newPage - 1) * this.pageSize,
        newPage * this.pageSize
      );
      this.$store.commit('users/setPage', page);
    },
    editUser(user) {
      user.address1 = user.address1.replace(/\s+/g, ' ');
      if (!user.useMainAddressForBilling) user.useMainAddressForBilling = false;

      this.$store.commit('users/setUserToEdit', Object.assign({}, user));
      this.displayEditUserPopup = true;
    },
    manageAccess(allUsers, accessControl, item) {
      console.log(
        '2',
        'allUsers',
        allUsers,
        'accessControl',
        accessControl,
        'currentUser',
        item
      );
      this.allUsers = allUsers;
      this.accessControl = accessControl;
      this.currentUser = item;

      this.showAccessControl = true;
    },
    openNewUserPopup() {
      this.$store.commit('users/setUserToEdit');
      this.displayAddUserPopup = true;
    },
    viewActivity(user) {
      sessionStorageService.set('selectedClientUser', {
        ...user,
        company: this.client?.company,
      });
      miscService.goToPage(
        `/admin/clients/${user.accountId}/users/${user.id}/activity`
      );
    },
    showHideFilters() {
      this.showFilters = !this.showFilters;
    },
  },
  computed: {
    ...mapGetters('users', ['all', 'page', 'filteredUsers', 'searchFilter']),
    pageHeader() {
      return `${this.client?.company}’s Employees Batch Upload`;
    },
    client() {
      return localStorageService.get('selected-afs-client');
    },
    pagingLength() {
      return Math.ceil(this.filteredUsers.length / this.pageSize);
    },
    backToLbl() {
      return "Back to Client's Users";
    },
    allUsersComputed() {
      return this.allUsers ?? [];
    },
    accessControlComputed() {
      return this.accessControl ?? [];
    },
    currentUserComputed() {
      return this.currentUser ?? {};
    },
  },
  watch: {
    searchFilter: {
      handler() {
        this.applyFilters();
      },
      deep: true,
    },
  },
});
